import { ASIDE_PANEL_LOCALSTORAGE, IAsidePanelLocalStorage } from '../types';

export const getAsidePanelLocalStorage = (): IAsidePanelLocalStorage => {
    const data = localStorage.getItem(ASIDE_PANEL_LOCALSTORAGE);
    const asidePanel = data? JSON.parse(data) : {};
    return asidePanel;
};
